import React from 'react';
export function EmptyLegs() {
  return <div className="pt-[72px] min-h-screen bg-white" data-id="element-260">
      <img src="https://cdn.magicpatterns.com/uploads/fG92EUXTs4FHnLu6Bbfq1W/Screenshot_2026-06-17_at_2.50.13_PM.png" alt="Empty legs — featured availability and route map" className="w-full h-auto" data-id="element-261" />
    </div>;
}